var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotApproved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1410086649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Body",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1142 27.1769C59.1981 27.1769 50.3488 36.0262 50.3488 46.9424V86.4732C50.3488 90.1119 47.3991 93.0617 43.7603 93.0617C40.1216 93.0617 37.1719 90.1119 37.1719 86.4732V46.9424C37.1719 28.7488 51.9207 14 70.1142 14C88.3078 14 103.057 28.7488 103.057 46.9424V86.4732C103.057 90.1119 100.107 93.0617 96.4681 93.0617C92.8294 93.0617 89.8797 90.1119 89.8797 86.4732V46.9424C89.8797 36.0262 81.0304 27.1769 70.1142 27.1769Z",
    fill: "#FB6E4F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape 5",
    filter: "url(#filter0_b_870_15896)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 53.5268,
    width: 92.2386,
    height: 72.4732,
    rx: 4,
    fill: "#FB6E4F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.3077,
    y: 53.8345,
    width: 91.6233,
    height: 71.8578,
    rx: 3.69231,
    stroke: "url(#paint0_linear_870_15896)",
    strokeWidth: 0.615382
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 117",
    d: "M57 77L83 103",
    stroke: "white",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 118",
    d: "M83 77L57 103",
    stroke: "white",
    strokeWidth: 8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_870_15896",
    x: 11.6924,
    y: 41.2192,
    width: 116.854,
    height: 97.0885,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.15382
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_870_15896"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_870_15896",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_870_15896",
    x1: 19.3881,
    y1: 58.7035,
    x2: 65.8917,
    y2: 149.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotApproved);
export default __webpack_public_path__ + "static/media/not-approved.de212c6dc42a43418adcec10110b3198.svg";
export { ForwardRef as ReactComponent };